<button type="button" class="text-blue mt-3 text-sm underline" (click)="clicked.emit()">
  {{ labelKey() | transloco }}
</button>
